// extracted by mini-css-extract-plugin
export var alertIcon = "_qo-0";